(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-gg-scent-guide]').forEach(guide => {
      if (guide.dataset.ggReady) return;
      const section = guide.closest('.gg-blend-guide');
      if (!section) return;
      guide.dataset.ggReady = 'true';
      guide.hidden = false;
      guide.addEventListener('click', event => {
        const button = event.target.closest('[data-gg-scent]');
        if (!button || !guide.contains(button)) return;
        const handle = button.dataset.ggScent;
        let selected;
        section.querySelectorAll('[data-gg-blend]').forEach(result => {
          const active = result.dataset.ggBlend === handle;
          result.hidden = !active;
          if (active) selected = result;
        });
        guide.querySelectorAll('[data-gg-scent]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
        const status = guide.querySelector('[data-gg-scent-status]');
        if (status) status.textContent = selected && selected.dataset.ggName ? guide.dataset.statusTemplate.replace('__NAME__', selected.dataset.ggName) : guide.dataset.statusAll;
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
